<template>
  <span>
      {{ formattedDate }}
  </span>
</template>

<script>
import moment from 'moment';
export default {
  name: "DateToHuman.vue",
  props: {
    date: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      formattedDate: null,
    }
  },
  mounted() {
    this.formattedDate = moment(this.date).format('DD/MM/YYYY');
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>